import * as Yup from 'yup';

const FundraisingTransactionValidator = () => Yup.object().shape({
  title: Yup.string().required(),
  ambassador_id: Yup.string().required(),
  event_id: Yup.string().required(),
  contact_id: Yup.string().required(),
  donor_name_displayed: Yup.string().required(),
  amount_multiplier: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .nullable(),
  pledge_date: Yup.date(),
  source_reference: Yup.string()
    .nullable(),
  source_reference_url: Yup.string()
    .url('Must be a valid URL (e.g., https://example.com)')
    .notRequired()
    .nullable(),
  donor_comment: Yup.string(),
});

export const FundraisingLinkValidator = () => Yup.object().shape({
  event_id: Yup.string()
    .when('is_linked', {
      is: (link: boolean) => link,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  donor_name_displayed: Yup.string()
    .when('is_linked', {
      is: (link: boolean) => link,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});

export default FundraisingTransactionValidator;
